<template>
  <layout-default-app-bar filterable
    :filters="filters">
    Clientes
  </layout-default-app-bar>
</template>



<script>
import { PESQUISA_CADASTRO_CLIENTE_QUERIES } from '@/constants/QUERY_FILTERS';

import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewCadastroPedidoAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  data() {
    return {
      filters: [
        PESQUISA_CADASTRO_CLIENTE_QUERIES.createdFrom,
        PESQUISA_CADASTRO_CLIENTE_QUERIES.createdBefore,
      ],
      titulo: 'Pesquisa',
    };
  },

  created() {
    const tipoPesquisa = this.$route.query.tipo;
    if (tipoPesquisa) {
      this.titulo = `Pesquisa de ${tipoPesquisa}`;
    }
  },

};

</script>

<style scoped>
  #icone{
    top: 6%;
    position: relative;
  }

  #texto {
    position: absolute;
    left: 120px;
    bottom: 8px;
    font-size: 24px;
  }
</style>
